export enum Role {
    ADMIN = '1',
    SUPER_PROVIDER = '2',
    PROVIDER = '3',
    PATIENT = '4',
    SUPER_USER = '5',
    MANAGING_USER = '6'
  }